var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.804688 0.142822H18.8047V18.1428H0.804688V0.142822Z",
    fill: "url(#pattern0_2568_1101)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.804688 0.142822H18.8047V18.1428H0.804688V0.142822Z",
    fill: "url(#pattern1_2568_1101)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2568_1101",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2568_1101",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_2568_1101",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2568_1101",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2568_1101",
    width: 32,
    height: 32,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAapJREFUWIXtl8tKw0AUhr+T1iq0a8E3ELwExY1CXago4iP4AoIoSsnChTsvYFJddePaB9C1KFiEulAwVV9CEQQVpbQZF0mp9zbVKSg9qwkzme87fyDJCAB2fhDUOsIAEEdvPaI4BVnC6s0J6YshlJcFIprB76uIkIzieWsIEVBbKFnGMh+1Ym03jsEKigUUm4LjPgBxFAnt8HJlrhI8Fe+BgkH5mTcKDjDb9RCMYkbDoF9UU6Ap0BTQI+CcT+C4tzj5xWpLo1rgyC7QBrRUW/67CWycj1fgaptUj13tltoTSLvHeLQCU1jm9Yf5N52rDClzDhFVbdvaE1C0IQwgHGC77b8BDycQK00CF0A3whFbpx3AJ7HXDg8nMN9/g2IMuAQ6KbXs4+SnMWSPSuczYeDhBAAs85pYaQQ/iS5QO9TZeX0C4CcRK40GEgTw0J3XL1CWiHjDKEZ/AoefvIgW++6AQ6y6dwD+7begKfDXBPzzgO3qPhNWKnOVCEYFwz8oAsLqqwm98OfianB1Jtj5QURl0fFz8n0VEZIGVm8OIQmcAIUGgAuAz0yZJy9QIJE9vJuAdwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.718261080bd778e725a89668f00fbbaa.svg";
export { ForwardRef as ReactComponent };